import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import 'rxjs'; // adds ALL RxJS statics & operators to Observable
// See node_module/rxjs/Rxjs.js
// Import just the rxjs statics and operators we need for THIS app.
// Operators
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, map, mergeMap, shareReplay, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { MenuActions } from '../../common/configuration/menu-actions';
import { CtxMenuSezioni } from '../../common/models/ctx-menu-sezioni';
import { ParcellaGiudiziale } from '../../common/models/parcella-giudiziale';
import { MotivoScadenzaAuto } from "../../common/models/tipologiche/motivo-scadenza-auto";
import { ServicePathsSettings } from '../configuration/service-paths-settings';
import { UrlSettingsCore } from "../configuration/url-settings-core";
import { TipoVisibilita } from 'src/app/common/models/tipologiche/tipo-visibilita';
import { UserInfo } from 'os';
import { UtenteLoggato } from 'src/app/common/models/utente-loggato';
import { AppData } from 'src/app/data-store';
import {DocumentoAllegato} from "../../common/models/documento-allegato";

declare var getPraticaMapSync;

@Injectable()
export class HelpersService {
  private http: HttpClient;
  public menuSezioni: CtxMenuSezioni;
  private praticaSubject = new BehaviorSubject<{idPratica: string, materia: string, oggetto: string} | null>({idPratica: '', materia: '', oggetto: ''});
  classificazione$ = this.praticaSubject.asObservable();

  constructor(http: HttpClient, private router: Router) {
    this.http = http;
  }


  /*loggedUser;
  user: BehaviorSubject < any > = new BehaviorSubject({
    value: false
  });
  userEmit = this.user.asObservable();

  setUser(request: any) {
    this.user.next(request);
  }

  get currentUser() {
    return this.user.asObservable();
  }*/

  loginSSO(user, pwd): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('TLF_USER', user);
    headers = headers.append('TLF_PASSWORD', pwd);
    headers = headers.append('TLF_RETE', '.rete.poste');
    return this.http.post(
      ServicePathsSettings.DOMINIO + '/' + UrlSettingsCore.URL_SSO,
      {user, pwd},
      {withCredentials: true, headers}
    )
  }

  logInReportSSO(user, pwd): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('TLF_USER', user);
    headers = headers.append('TLF_PASSWORD', pwd);
    headers = headers.append('TLF_RETE', '.rete.poste');
    return this.http.post(
      environment.url + 'report/' + UrlSettingsCore.URL_SSO,
      {user, pwd},
      {withCredentials: true, headers}
    )
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if ((error = new HttpResponse())) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = '${error.status} - ${error.statusText || \'\'} ${err}';
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return throwError(errMsg);
  }

  getDescrittoriSezione(
    azione: MenuActions,
    idTipoPratica: any,
    idTipoFascicolo: any,
    idFascicolo: any
  ): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      if (
        azione === MenuActions.VISUALIZZA_FASCICOLO ||
        azione === MenuActions.INSERISCI_FASCICOLO ||
        azione === MenuActions.CREA_FASCICOLO
      ) {
        return this.http.get(
          '../../../LocalJson/descrittoriSezioneFascicolo.json'
        );
      } else if (azione === MenuActions.VISUALIZZA_PRATICA) {
        return this.http.get(
          '../../../LocalJson/descrittoriSezionePratica.json'
        );
      } else if (azione === MenuActions.CREA_PRATICA) {
        return this.http.get(
          '../../../LocalJson/descrittoriSezionePratica.json'
        );
      }
    } else {
      // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPratica];
      const pratica = getPraticaMapSync(idTipoPratica);
      if (
        azione === MenuActions.VISUALIZZA_FASCICOLO ||
        azione === MenuActions.INSERISCI_FASCICOLO ||
        azione === MenuActions.CREA_FASCICOLO
      ) {
        return this.http.get(
          ServicePathsSettings.DOMINIO +
          pratica.pathDescrittori +
          ServicePathsSettings.URL_FASCICOLO +
          '/' +
          idTipoPratica +
          '/' +
          idTipoFascicolo +
           '/' +
          idFascicolo
        );
      } else if (
        azione === MenuActions.VISUALIZZA_PRATICA ||
        azione === MenuActions.INSERISCI_FASCICOLO_E_VEDI_PRATICA
      ) {
        return this.http.get(
          ServicePathsSettings.DOMINIO +
          pratica.pathDescrittori +
          ServicePathsSettings.URL_PRATICA +
          '/' +
          idTipoPratica
        );
      } else if (azione === MenuActions.CREA_PRATICA) {
        return this.http.get(
          ServicePathsSettings.DOMINIO +
          pratica.pathDescrittori +
          ServicePathsSettings.URL_PRATICA +
          '/' +
          idTipoPratica
        );
      }
    }
  }

  getDescrittori(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_GET_DESCRITTORI
    );
  }

  getUserRole(userName): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.OPERATIONS_PATH +
      '/utente/' +
      userName
    ).pipe(
      map((response:any) => {
        AppData.getInstance().userRoles = response.utente.ruoli;
        let rolVisibilita = response.utente.ruoli.filter(el => el.id.includes('ROL_VISIBILITA'));
        AppData.getInstance().setTipiVisibilita(rolVisibilita);
      })
    )
  }

  getMateria(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_MATERIA_PRATICA
    );
  }

  getOggetti(idMateria: string): Observable<any> {
    let url = ServicePathsSettings.URL_OGGETTI_PRATICA;
    url = url.replace('{idMateria}', idMateria);
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  getArgomenti(idMateria: string, idOggetto: string): Observable<any> {
    let url = ServicePathsSettings.URL_ARGOMENTI_PRATICA;
    url = url
      .replace('{idMateria}', idMateria)
      .replace('{idOggetto}', idOggetto);
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  getTipiPetitum(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_PETITUM
      );
    }
  }

  getGradiRischio(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GRADI_RISCHIO_PRATICA
      );
    }
  }

  getGradi(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('../local/getGradi.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_GRADI_PRATICA
      );
    }
  }

  getAutoritaGiudiziarie(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_AUTORITA_GIUDIZIARIE_PRATICA
    );
  }

  getAutoritaGiudiziarieByFascicoloGrado(idTipoPratica: string, idTipoFascicolo: string, idGrado: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_AUTORITA_GIUDIZIARIE_PRATICA + "/"
      + idTipoPratica + "/" + idTipoFascicolo + "/" + idGrado
    );
  }

  getSediTerritoriale(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_SEDE_TERRITORIALE
    );
  }

  getModalitaPartecipazioni(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_MODALITA_PARTECIPAZIONI
    );
  }

  getSoggetti(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('local/getArgomenti.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_SOGGETTI_PRATICA
      );
    }
  }

  // getSoggettiByIdPratica(idPratica): Observable <any>{
  //   return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_SOGGETTI_BY_ID_PRATICA.replace('{idPratica}', idPratica));
  // }

  getTipiLiquidato(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_LIQUIDATO
    );
  }

  getTipoRisoluzioni(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPO_RISOLUZIONE_PRATICA
    );
  }

  getOrganiIspettivi(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_ORGANI_ISPETTIVI_PRATICA
    );
  }

  getListaFori(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_LISTA_FORO
    );
  }

  getTipiReato(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('local/getArgomenti.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_REATO
      );
    }
  }

  getTipiIndaginePreliminare(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('local/getArgomenti.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_TIPI_INDAGINE_PRELIMINARE
      );
    }
  }

  getCittaPerAutoritaGiudiziaria(
    idAutoritaGiudiziaria: string
  ): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('../local/getCittaPerAutoritaGiudiziaria.json');
    } else {
      let url = ServicePathsSettings.URL_CITTA_BY_AUTORITA_PRATICA;
      url = url.replace('{idAutoritaGiudiziaria}', idAutoritaGiudiziaria);
      return this.http.get(ServicePathsSettings.DOMINIO + url);
    }
  }

  getCategorieLegaleIncaricato(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('../local/getCategorieLegaleIncaricato.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_CATEGORIE_LEGALE_INCARICATO_PRATICA
      );
    }
  }

  getTipiProvenienza(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('local/getArgomenti.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_TIPI_PROVENIENZA_PRATICA
      );
    }
  }

  getTipiCatasto(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('local/getTipoCatasto.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_GET_TIPO_CATASTO
      );
    }
  }

  getTipiDirittoReale(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('local/getTipoDirittoReale.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_TIPI_DIRITTO_REALE
      );
    }
  }

  getTipiDenuncia(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
      return this.http.get('local/getTipoDenuncia.json');
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_GET_TIPO_DATI_DENUNCIA
      );
    }
  }

  getTipiEsiti(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_ESITI_PRATICA
    );
  }

  getTipiAtto(): Observable<any> {
    if (ServicePathsSettings.isLocal) {
    } else {
      return this.http.get(
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_TIPI_ATTO_PRATICA
      );
    }
  }

  getProvince(): Observable<any> {
    return this.http
      .get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_PROVINCE_PRATICA
      )
      .pipe(shareReplay());
  }

  getTipiProvaScritta(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_TIPI_PROVA_SCRITTA
    );
  }

  getCitta(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_CITTA_PRATICA
    );
  }

  getCittaByProvincia(idProvincia: string): Observable<any> {
    let url = ServicePathsSettings.URL_CITTA_PRATICA;
    url = url.replace('{idProvincia}', idProvincia);
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  getTipiSocieta(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_SOCIETA_PRATICA
    );
  }

  getTipiPersona(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_PERSONA_PRATICA
    );
  }

  getEsitiPerSocieta(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_ESITI_BY_SOCIETA_PRATICA
    );
  }

  getTipiRevocazione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_REVOCAZIONE
    );
  }

  getTipiScadenza(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_SCADENZA_PRATICA
    );
  }

  getMotiviScadenza(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_MOTIVI_SCADENZA_PRATICA
    );
  }

  getMotiviScadenzaAutomatica(): Observable<MotivoScadenzaAuto[]> {
    return this.http
      .get(
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_MOTIVI_SCADENZA_PRATICA
      )
      .pipe(
        map((res) => (res as MotivoScadenzaAuto[]) || []), // res.json() todo: testing
        catchError(this.handleError)
      );
  }

  getMotiviRinvioScadenza(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_MOTIVI_RINVIO_SCADENZA_PRATICA
    );
  }

  getMotiviEvadiScadenza(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_MOTIVI_EVADI_SCADENZA_PRATICA
    );
  }

  getPrioritaScadenza(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_PRIORITA_SCDENZA_PRATICA
    );
  }

  getAssegnatariAdempimenti(idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_ASSEGNATARI_ADEMPIMENTI.replace("{idFascicolo}", idFascicolo)
    );
  }

  getUtentiNotifica(idFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_UTENTI_NOTIFICA.replace("{idFascicolo}", idFascicolo)
    );
  }

  getAmbitiCompetenza(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_AMBITO_COMPETENZA_PRATICA
    );
  }

  getTipiNatura(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_NATURA_PRATICA
    );
  }

  getTipiAutoritaIndipendente(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_AUTORITA_INDIPENDENTE
    );
  }

  getTipiArbitrato(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_ARBITRATO_PRATICA
    );
  }

  getTipiNegoziazione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_NEGOZIAZIONE
    );
  }

  getCategorieAltraParte(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_CATEGORIE_ALTRA_PARTE
    );
  }

  getCategorieControparte(tipoFascicolo): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_PATH_HELPERS +
      '/' +
      tipoFascicolo +
      ServicePathsSettings.URL_CATEGORIE_CONTROPARTE
    );
  }

  getTipiDocumenti(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_DOCUMENTI_DOCUMENTAZIONE_ALLEGATA
    );
  }

  getTipiVisibilitaDocumento(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_VISIBILITA_DOCUMENTO
    );
  }

  getTipiPratica(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_PRATICA_GRUPPO_OPERATIVO
    );
  }

  getAllOfficeTypes(nomeUfficio:string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.PROTOCOL_UFFICI_PATH  + nomeUfficio
    );
  }

  getTipiPraticaSearch(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_PRATICA
    );
  }

  getAllTipiFascicolo(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ALL_TIPI_FASCICOLO
    );
  }

  getIva(): Observable<any> {
    return this.http
      .get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_IVA)
      .pipe(shareReplay());
  }

  getCpa(): Observable<any> {
    return this.http
      .get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_CPA)
      .pipe(shareReplay());
  }

  getCodice(tipoPratica?: string): Observable<any> {
    let endpoint = tipoPratica ? tipoPratica : "all";
    return this.http
     .get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_CODICE_FASCICOLO+'/'+ endpoint)
     .pipe(
       shareReplay(),
       map((items:any) => items.sort((a, b) => a.codice.localeCompare(b.codice)))
     );
  }

  getFasiFascicolo(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_FASI_FASCICOLO
    );
  }

  getMenuFascicolo(idTipoPratica: string, idTipoFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.URL_MENU_FASCICOLO(idTipoPratica, idTipoFascicolo)
    );
  }

  getDescrittoriFascicolo(tipoPratica: string, idTipoPratica: string, idTipoFascicolo: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.URL_DESCRITTORI_FASCICOLO(tipoPratica, idTipoPratica, idTipoFascicolo)
    );
  }

  getTipiFase(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_FASE
    );
  }

  getTipiFascicolo(idTipoPratica): Observable<any> {
    let url = ServicePathsSettings.URL_TIPI_FASCICOLO;
    url = url.replace('{idTipoPratica}', idTipoPratica);
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  getMotiviPagamento(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_MOTIVI_PAGAMENTO
    );
  }

  getTipiSommaLiquidata(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_SOMMA_LIQUIDATA
    );
  }

  getTipiSommaDaCorrispondere(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_SOMMA_DA_CORRISPONDERE
    );
  }

  getModalitaErogazione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_MODALITA_EROGAZIONE
    );
  }

  getTipiPagamento(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_PAGAMENTO
    );
  }

  getModalitaPagamento(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_MODALITA_PAGAMENTO
    );
  }

  getTipiDettaglioEsito(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_DETTAGLIO_ESITO
    );
  }

  getStatiEntita(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_STATI_ENTITA
    );
  }

  getStatiPratica(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_STATI_PRATICA
    );
  }

  /*downloadDocument(idDocumento: string) {
    let url =
      ServicePathsSettings.DOMINIO + ServicePathsSettings.DOWNLOAD_DOCUMENTO;
    window.location.href = url + "/" + idDocumento;
    //return this.http.get( ServicePathsSettings.DOMINIO + ServicePathsSettings.DOWNLOAD_DOCUMENTO + '/' + idDocumento)
  }*/

  downloadDocument(idDocumento: string): Observable<any> {
    return this.http
      .get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.DOWNLOAD_DOCUMENTO + '/' +
        idDocumento,
        {
          responseType: 'arraybuffer',
          observe: 'response',
          withCredentials: true,
        }
      )
      .pipe(this.download_operator);
  }

  downloadZipFile(refDocumentaleZip: string): Observable<any> {
    const url = `${ServicePathsSettings.DOMINIO}${ServicePathsSettings.DOWNLOAD_ALL_DOCUMENTS}`;  
    let response = this.http.get(url + "/" + refDocumentaleZip, {
        observe: 'response',
        responseType: 'blob' as 'json'
      });
    return response;
  }

  downloadCSV(dataInizio: string, dataFine: string): Observable<any> {
    return this.http
      .get(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.DOWNLOAD_CSV,
        {
          params: { dataInizio, dataFine },
          responseType: 'arraybuffer',
          observe: 'response'
        }
      )
  }

  getDocumentoAllegato(idDocumento: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_DOCUMENTO +
      '/' +
      idDocumento
    );
  }

  downloadDocumentoByIdDocumentale(ref: string, idVersione: string) {
    const url =
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.DOWNLOAD_DOCUMENTO_BY_ID_DOCUMENTALE + '/' + ref + '/' + idVersione;
    return this.http
      .get(url,
        {
          responseType: 'arraybuffer',
          observe: 'response',
          withCredentials: true,
        }
      )
      .pipe(this.download_operator);
  }

  downloadDocumentoByIdDocumentaleVersionHistory(ref: string) {
    const url =
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.DOWNLOAD_DOCUMENTO_BY_ID_DOCUMENTALE + '/' + ref;
    return this.http
      .get(url,
        {
          responseType: 'arraybuffer',
          observe: 'response',
          withCredentials: true,
        }
      )
      .pipe(this.download_operator);
  }

  
  showPreviewWithRefDocumentale(ref: string) {
    const url =
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.DOWNLOAD_DOCUMENTO_BY_ID_DOCUMENTALE + '/' + ref;
    return this.http
      .get(url,
        {
          responseType: 'arraybuffer',
          observe: 'response',
          withCredentials: true,
        }
      );
  }


  getDocumentoByIdDocumentale(ref: string, idVersione: string): Observable<any> {
    const url =
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.DOWNLOAD_DOCUMENTO_BY_ID_DOCUMENTALE + '/' + ref + '/' + idVersione;
    return this.http
      .get(url,
        {
          responseType: 'arraybuffer',
          observe: 'response',
          withCredentials: true,
        }
      ).pipe(
        map((res: HttpResponse<any>) => {
            return URL.createObjectURL(new Blob([res.body], {
              type: 'application/pdf',
            }));
          }
        )
      )
}

getDocumentoByIdDocumento(idDocumento: string,  preview: boolean = false): Observable<any> {
  const url =
    ServicePathsSettings.DOMINIO
    + ServicePathsSettings.DOWNLOAD_DOCUMENTO
    + '/'
    + idDocumento
    + '?preview='
    + preview;
  return this.http
    .get(url,
      {
        responseType: 'arraybuffer',
        observe: 'response',
        withCredentials: true,
      }
    ).pipe(
      map((res: HttpResponse<any>) => {

        if (res.body) {
          const text = new TextDecoder('utf-8').decode(res.body.slice(0, 100));
        }

        const blob = new Blob([res.body], {type: 'application/pdf'});
        return {
          blob: blob,
          contentDisposition: res.headers.get('Content-Disposition')
        };
      })
    );
}

  getPreview(idDocumento: string): Observable<any> {
    const url =
      ServicePathsSettings.DOMINIO
      + ServicePathsSettings.DOWNLOAD_DOCUMENTO
      + '/'
      + idDocumento;
    return this.http
      .get(url,
        {
          responseType: 'arraybuffer',
          observe: 'response',
          withCredentials: true,
        }
      )
  }


  viewDoc(documento: DocumentoAllegato) {
    if (!documento.id) {
      return;
    }
    this.getDocumentoByIdDocumento(documento.id, true).subscribe({
      next: (response) => {
        const contentDisposition = response.contentDisposition ?? '';
        let filename = 'documento.pdf';
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }

        const blob = response.blob;
        if (!blob) {
          console.error('Il blob è vuoto');
        }

        const blobUrl = URL.createObjectURL(blob);

        const htmlContent = `
          <html>
            <head><title>${filename}</title></head>
            <body style="margin:0">
              <iframe src="${blobUrl}" frameborder="0" style="width:100%;height:100%"></iframe>
            </body>
          </html>
        `;
        const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
        const htmlBlobUrl = URL.createObjectURL(htmlBlob);
        window.open(htmlBlobUrl, '_blank');

      },
      error: (err) => {
        console.log('Errore nel download documento:', err);
      }
    });
  }


  retrieveVersionHistory(idFile: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_HISTORY_DOCUMENT_VERSION +
      '/' +
      idFile
    );
  }

  getCompetenzeParcella(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_COMPETENZE_PARCELLA
    );
  }

  getCompetenzeParcellaPratFasc(
    idTipoPratica,
    idTipoFascicolo
  ): Observable<any> {
    let url = ServicePathsSettings.URL_COMPETENZE_PARCELLA_PRATICA_FASCICOLO;
    url = url.replace('{idTipoPratica}', idTipoPratica);
    url = url.replace('{idTipoFascicolo}', idTipoFascicolo);
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  getScaglioniParcella(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_SCAGLIONI_PARCELLA
    );
  }

  getValoriRiferimentiParcellaByScaglione(
    idScaglioneParcella: string
  ): Observable<any> {
    let url = ServicePathsSettings.URL_VALORI_PARCELLA_BY_SCAGLIONE;
    url = url.replace('{idScaglioneParcella}', idScaglioneParcella);
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  getTipiLetteraDiffida(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_LETTERA_DIFFIDA
    );
  }

  getTipiEsitoSpedizione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPO_ESITO_SPEDIZIONE
    );
  }

  getMotiviEsitoSpedizione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_MOTIVO_ESITO_SPEDIZIONE
    );
  }

  getLoggedUserData(): Observable<any> {
    return this.http.get<any>(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_LOGGER_USER_DATA
    );
  }

  getRolesByUserData(): Observable<any>  {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_LOGGER_USER_DATA
    ).pipe(
      mergeMap((res: UtenteLoggato) => {return this.getUserRole(res.username)})
    )
  }

  getToken(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.GET_TOKEN_PATH,
      {responseType: 'text'}
    );
  }

  buildProspettoParcella(
    parcellaGiudiziale: ParcellaGiudiziale
  ): Observable<any> {
    return this.http.put(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_BUILD_PARCELLA,
      parcellaGiudiziale
    );
  }

  getTipoTitolo(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_TIPO_TITOLO_ESECUTIVO
    );
  }

  getDirezioniTerritorialiLavoro(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_DIREZIONI_TERRITORIALI_LAVORO
    );
  }

  getSottoTipoTitolo(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_SOTTO_TIPO_TITOLO_ESECUTIVO
    );
  }

  getSottoTipoTitoloByTipoTitolo(idTipoTitolo: string): Observable<any> {
    let url =
      ServicePathsSettings.URL_GET_SOTTO_TIPO_TITOLO_ESECUTIVO_BY_TIPO_TITOLO;
    url = url.replace('{idTipoTitolo}', idTipoTitolo);
    return this.http.get(ServicePathsSettings.DOMINIO + url);
  }

  getTipiBeneMobile(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_TIPI_BENE_MOBILI
    );
  }

  getTipiRitoAlternativo(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_RITO_ALTERNATIVO
    );
  }

  getMotiviDefinizione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_MOTIVI_DEFINIZIONE
    );
  }

  getGruppiOperativi(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_TEMPLATE_GRUPPI_OPERATIVI
    );
  }

  getGruppiByPermessi(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_TEMPLATE_PERMESSI
    );
  }

  prendiOggettiAttivi(): Observable<any> {
    const response = this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_OGGETTI_ATTIVI
    );
    return response;
  }

  prendiArgomentiAttivi(): Observable<any> {
    const response = this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ARGOMENTI_ATTIVI
    );
    return response;
  }

  prendiMaterieAttive(): Observable<any> {
    const response = this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_MATERIE_ATTIVE
    );
    return response;
  }

  prendiTipologicheMaterie(): Observable<any> {
    const response = this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPOLOGICHE_MATERIE
    );
    return response;
  }

  getTipologicheOggetto(idMateria: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_MATERIA_OGGETTI.replace(
        '{idMateria}',
        idMateria
      )
    );
  }

  getTipologicheArgomenti(idMateriaOggetto: string): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_MATERIA_OGGETTO_ARGOMENTI.replace(
        '{idMateriaOggetto}',
        idMateriaOggetto
      )
    );
  }

  changeTenant(selectedTenant: string) {
    return this.http.put(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_GET_LOGGER_USER_DATA +
      '/tenant/' +
      selectedTenant,
      selectedTenant
    );
  }

  getTipiEsecuzione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_ESECUZIONE
    );
  }

  getTipiSchedaEsecuzione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI_SCHEDA_ESECUZIONE
    );
  }

  getTipiRicorso(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_RICORSO
    );
  }

  getTipiOpposizione(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_OPPOSIZIONE
    );
  }

  getProfili(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_PROFILI
    );
  }

  getImpianti(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_IMPIANTI
    );
  }

  getContratti(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_CONTRATTI
    );
  }

  getTipiDipendente(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_DIPENDENTE
    );
  }

  getTipiStatiDipendente(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPI__STATI_DIPENDENTE
    );
  }

  getContrattiBySocieta(idSocieta): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_SOGGETTO_PRATICA +
      '/' +
      idSocieta +
      '/tipiContratto'
    );
  }

  getFigureProfessionaliByContratto(idTipoContratto): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_FIGURE_PROFESSIONALI +
      '/' +
      idTipoContratto
    );
  }

  getFigureProfessionali(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_FIGURE_PROFESSIONALI_TPL
    );
  }

  getSanzioniByContratto(idContratto): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.URL_TIPO_CONTRATTO +
      '/' +
      idContratto +
      '/tipisanzione'
    );
  }

  getLavoratori(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_LAVORATORI
    );
  }

  getSanzioni(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_SANZIONI
    );
  }

  getProvvedimenti(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_PROVVEDIMENTI
    );
  }

  getComuni(): Observable<any> {
    return this.http
      .get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_COMUNI)
      .pipe(shareReplay());
  }

  getTipiGiudizi(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_GIUDIZI
    );
  }

  logout(): Observable<any> {
    return this.http.get(ServicePathsSettings.LOGOUT_PATH, {
      responseType: 'text',
    });
  }

  logoutReport(): Observable<any> {
    return this.http.get(environment.url + 'report/logout', {
      responseType: 'text',
    });
  }

  getTipiData(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.HELPERS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH +
      '/tipidata'
    );
  }

  getTipiDanno(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.HELPERS_PATH + '/gp/tipidanno')
  }

  getPresidi(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.HELPERS_PATH + '/gp/presididistretti')

  }

  getCanaliApertura(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.HELPERS_PATH + '/gp/canaliapertura')
  }

  getTipiValutazione(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.HELPERS_PATH + '/gp/tipivalutazione')
  }

  getTipoMotivazione(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_MOTIVAZIONE)
  }

  getTipologiaGenericoGiudiziale(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPOLOGIA_GENERICO_GIUDIZIALE)
  }

  getTipologiaGenericoConsulenza(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPOLOGIA_GENERICO_CONSULENZA)
  }


  getStatiLavorazione(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.HELPERS_PATH + '/gp/statilavorazione')
  }

  // LIST
  getTipiProvenienzaDocumento(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.HELPERS_PATH + '/gp/tipiprovenienzadocumento')
  }

  // CRUD
  getTipoProvenienzaDocumento(): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION + '/gp/tipoprovenienzadocumento')
  }

  getOggettiRicorso(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.HELPERS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH +
      '/tipioggettoricorso'
    );
  }

  getOrganiCompetenti(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.HELPERS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH +
      '/tipiorganocompetentericamm'
    );
  }

  getTipoDocumenteFromTipoAtto(tipoAtto: string): Observable<any> {
    return this.http.get(ServicePathsSettings.DOMINIO + ServicePathsSettings.HELPERS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/tipidocumento/' + tipoAtto)
  }

  download_operator(
    source$: Observable<HttpResponse<any>>
  ): Observable<HttpResponse<any>> {
    return source$.pipe(
      tap((res: HttpResponse<any>) => {
        const filename = res.headers
          .get('content-disposition')
          .split('filename=')[1];
        const blob = new Blob([res.body], {
          type: 'application/octet-stream',
        });
        const url = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        window.document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        window.document.body.removeChild(a);
      })
    );
  }

  getTipiVisibilita(): Observable<any> {
    return this.http.get(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_RISERVATEZZA
    );
  }

  updatePratica(idPratica: string, materia: string, oggetto: string) {
    this.praticaSubject.next({idPratica, materia, oggetto});
  }

  searchByProtocollo(numeroProtocollo: string, flagAttoPrincipale:boolean): Observable<any[]> {
    return this.http.post<any[]>(
      ServicePathsSettings.DOMINIO + ServicePathsSettings.SEARCH_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH +'/fascicoli/searchprotocollo', { numeroProtocollo,flagAttoPrincipale});
  }

  checkDeleteDocumento(idSezione: number | string, idDocumento: number | string): Observable<boolean> {
    const url = 
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.OPERATIONS_PATH +
      ServicePathsSettings.GESTIONE_PRATICHE_PATH +
      `/${idSezione}/checkDeleteDocumento/${idDocumento}`;

    return this.http.get<boolean>(url);
  }
  impostaPrincipale(
    payload: { idDocumento: string, idFascicoloPrincipale: string, idSezione:string },
    ): Observable<any> {
      const url = ServicePathsSettings.DOMINIO 
      + ServicePathsSettings.OPERATIONS_PATH 
      + ServicePathsSettings.GESTIONE_PRATICHE_PATH
      + '/changeattoprincipale'

    return this.http.put(url, payload);
  }
  /**
   * extractPdfFromP7m
   * Extracts PDF file encapsuleted in a P7M wrapper
  */
  public extractPdfFromP7mDocAllegata(idDocumento:any, versione = null): Observable<any> {
    // ServicePathsSettings.GESTIONE_PRATICHE_PATH
    let endpoint = versione ? `/gp/p7m/preview/${idDocumento}?versione=${versione}` : `/gp/p7m/preview/${idDocumento}`;
    let url = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH +  endpoint;
    return this.http.get(url, {
        responseType: 'arraybuffer',
        observe: 'response',
        withCredentials: true,
      });
  }

}
